import { ref, isRef } from 'vue';

/**
 * @template T
 * @typedef FetchApi
 * @property {import('vue').Ref<T>} result
 * @property {import('vue').Ref<boolean>} isLoading
 * @property {import('vue').Ref<null>} error
 * @property {(...args: any[]) => Promise<void>} fetch
 * }}
 */

/**
 * @template T
 * @param {(...args: any[]) => Promise<T>} getResult
 * @param {Object} [params]
 * @param {import('vue').Ref<Nullable<T>> | Nullable<T>} [params.initialValue]
 * @returns {FetchApi<T>}
 */
export default function useFetch(getResult, params = { initialValue: null }) {
  const result = isRef(params.initialValue) ? params.initialValue : ref(params.initialValue || null);
  const isLoading = ref(false);
  const error = ref(null);

  async function fetch(...args) {
    isLoading.value = true;
    error.value = null;
    try {
      result.value = await getResult(...args);
    } catch (e) {
      console.error(e);
      error.value = e;
    } finally {
      isLoading.value = false;
    }
  }

  const resetError = () => {
    error.value = null;
  };

  return {
    result,
    isLoading,
    error,
    fetch,
    resetError,
  };
}
